import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: "",
  type: "",
  show: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state, action) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.show = true;
      state.startTime = Date.now();
    },
    clearNotification: (state) => {
      state.message = "";
      state.type = "";
      state.show = false;
      state.startTime = null;
    },
  },
});

export const { setNotification, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
